/**
 * Класс преобразователь ошибок полученных по апи
 */
export class ApiErrorTransformer {
  /**
   * Метод преобразует ошибку в строку
   *
   * @param data данные об ошибке
   */
  transformErrorToString ({ data }) {
    const message = data.message === undefined ? '' : data.message

    return message + Object.values(data.errors).join(' ')
  }
}
